const TEXTS = {
    cdc: 'Centers for Disease Control and Prevention',
    cdc_subtext: 'CDC 24/7 Saving Lives Protecting People&trade;',
    svi: '(Social Vulnerability Index)',
    cdc_banner: 'CDC/ATSDR SVI',
    popup: {
        featureInfo: {
            label: 'Identify Result',
            button: 'Social Vulnerability Info'
        }
    },
    modals: {
        download: {
            label: 'Select Information for Download',
            link: 'Select All',
            maplabel: 'Map (JPG)',
            datalabel: 'Data (CSV)',
            titleCheck: 'Title',
            legendCheck: 'Legend',
            currentMap: 'Current Map View',
            currentData: 'Current Data Selections',
            select_state: 'Select State',
            select_county: 'Select County',
            usmap: 'United States',
            button: 'Download'
        },
        autoSwitchCensus: {
            text: 'Geographic Unit switched to County. Census tracts can be accessed again by zooming in and toggling to the Census Tracts Geographic Unit.'
        },
        autoSwitchDCtract: {
            text: 'There is no State comparison data for county, switched to census'
        }
    },
    legend: {
        label: 'Level of Vulnerability',
        tooltip: 'Legend',
        low: {
            label: 'Low',
            tooltip: '0.0-0.25 (Least Vulnerable 25%)'
        },
        med: {
            label: 'Low-Medium',
            tooltip: '0.2501-0.50'
        },
        high: {
            label: 'Medium-High',
            tooltip: '0.5001-0.75'
        },
        top: {
            label: 'High',
            tooltip: '0.7501-1.0 (Most Vulnerable 25%)'
        },
        none: {
            label: 'No Data',
            tooltip: 'No Data'
        },
        non_applicable: {
            label: 'N/A',
            tooltip: 'Area out of scope'
        }
    },
    controls: {
        svi_select: {
            label: 'SVI Theme',
            tooltip: 'Select Overall SVI or one of the SVI themes to display on the map',
            tooltiptable: 'Select Overall SVI or one of the SVI themes to display in the table'
        },
        comparison: {
            label: 'Geographic Comparison',
            option1: 'Nationwide',
            option2: 'Statewide',
            tooltip: 'Toggle to view nationwide or statewide data comparison level'
        },
        state_select: {
            label: 'State Selection',
            placeholder: 'Select',
            tooltip: 'Choose state/district/territory',
            disabled: 'Switch Geographic Comparison to Statewide to select a state/district/territory'
        },
        data_level: {
            label: 'Geographic Unit',
            option1: 'County',
            option2: 'Census Tract',
            tooltip: 'Toggle to view SVI data at either county level or census tract level',
            disabled: 'Toggle to view SVI data at either county level or census tract level',
            helpText: 'Jump to **Zoom Level 8** to view Census Tracts'
        },
        data_year: {
            label: 'Data Year',
            tooltip: 'Select SVI data year'
        },
        reset_button: {
            label: 'Reset',
            tooltip: 'Click to reset data selections',
            resetTooltip: 'To view all of the SVI data, click to reset data selections'
        },
        poi_select: {
            label: 'Map Features',
            placeholder: 'Click to view',
            tooltip: 'Click to choose map feature layers'
        },
        svi_opacity: {
            label: 'Map Transparency',
            tooltip: 'Scroll to adjust transparency levels of the selected SVI layer'
        },
        search_box: {
            label: 'Find address, county, or ZIP code',
            tooltip: 'Although search for ZIP or address is available, results will only show county or census tract information'
        },
        zoom_level: {
            tooltip: 'Zoom level'
        },
        zoom_in: {
            tooltip: 'Zoom in on map'
        },
        zoom_out: {
            tooltip: 'Zoom out on map'
        },
        reset_to_full_extent: {
            tooltip: 'Zoom to original map view'
        },
        night_day_mode: {
            tooltip: 'Switch between night and day mode'
        },
        full_screen: {
            tooltip: 'View in full screen'
        },
        zoom_select: {
            tooltip: 'Click and Drag to Zoom'
        },
        download: {
            tooltip: 'Download…'
        },
        expandCollapse: {
            tooltip: 'Click to hide/expand data selections'
        }
    },
    errorMessages: {
        101: {
            name: 'DataServiceError',
            devNotes: 'An error occured that not been yet documented in this app.',
            message: 'Unknown Error'
        },
        400: {
            name: 'URLError',
            devNotes: 'Problem generating url string (probably in code)',
            message: 'An error occured loading the page'
        },
        403: {
            name: 'Permission Error',
            devNotes: 'Expired Password',
            message: 'An error occured loading the page'
        },
        401: {
            name: 'LoginAttemptError',
            devNotes: 'API User/password is wrong',
            message: 'An error occured loading the page'
        },
        405: {
            name: 'LoginAttemptError',
            devNotes: 'API User/password is wrong',
            message: 'An error occured loading the page'
        },
        498: {
            name: 'TokenError',
            devNotes: 'Token may have expired or was overriden by another cient',
            message: 'An error occured loading the page'
        },
        405: {
            name: 'DataServiceError',
            devNotes: 'Too many login attempts with incorrect credentials',
            message: 'An error occured loading the page'
        },
        503: {
            name: 'DataServiceError',
            devNotes: 'server is down',
            message: 'Server is unavailable'
        }
    }
};
export default TEXTS;
